export enum SgmEventType {
  ERROR = 1,
  WARN = 2,
  INFO = 3,
}

export interface SgmEventMessage {
  page: string;
  vehicleName?: string;
  action: string;
  trigger: string;
  requestId: string | number | null;
  result?: string;
  reason?: string;
  [key: string]: unknown;
}

interface SgmEvent {
  type: SgmEventType;
  code: string;
  msg: SgmEventMessage;
  cost1?: number;
  cost2?: number;
  cost3?: number;
  cost4?: number;
}

const truncate = (value: string, maxLength: number) =>
  value.length > maxLength ? value.slice(0, maxLength) : value;

const normalizeCost = (cost?: number) =>
  typeof cost === 'number' && Number.isFinite(cost) ? Math.round(cost) : undefined;

/**
 * Reports an SGM custom event without letting telemetry affect page behavior.
 * The configured page-level PID in static/index.html is intentionally reused.
 */
export const reportSgmEvent = ({
  type,
  code,
  msg,
  cost1,
  cost2,
  cost3,
  cost4,
}: SgmEvent) => {
  try {
    const custom = (window as any).__sgm__?.custom;
    if (typeof custom !== 'function') {
      return;
    }

    const payload: Record<string, string | number> = {
      type,
      code: truncate(String(code), 128),
      msg: truncate(JSON.stringify(msg), 1024),
    };
    const costs = [cost1, cost2, cost3, cost4];
    costs.forEach((cost, index) => {
      const normalizedCost = normalizeCost(cost);
      if (normalizedCost !== undefined) {
        payload[`cost${index + 1}`] = normalizedCost;
      }
    });

    custom(payload);
  } catch {}
};
